import { createContext } from "react";

export const AuthContext = createContext({
    isLoggedIn: false,
    userId: null,
    token: null,
    role: null,
    otherUserId: null,
    login: () => {},
    logout: () => {},
    getOtherUserId: () => {}
})